<template>
  <v-dialog
    v-model="show"
    width="500px">
    <div class="dialog-container">
      <template>
        <p>
          {{ message }}
        </p>
      </template>
      <div class="flex-sb dialog-footer">
        <div>
          <v-button
            @click="onCancel">{{ cancelBtn }}</v-button>
        </div>
        <div>
          <v-button
            type="primary"
            @click="onConfirm">{{ confirmBtn }}</v-button>
        </div>
      </div>
    </div>

  </v-dialog>
</template>

<script>
export default {
  name: 'renew-insurer-dialog',
  props:{
    value: {
      type: Boolean,
      default: false
    },
    confirmBtn: {
      type: String,
      default: 'Yes'
    },
    cancelBtn: {
      type: String,
      default: 'Cancel'
    },
    message: {
      type: String,
      default: ''
    },
  },
  data(){
    return{
      show:false,
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.show = val
      }
    },
  },
  methods:{
    onCancel(){
      this.$emit('update',false)
      this.$emit('input',false)
    },
    onConfirm(){
      this.$emit('update',true)
      this.$emit('input',false)
    },
  }
}
</script>

<style lang="scss" scoped>
.dialog-container {
  padding: 15px;
  color: #616266;
  h2 {
    font-size: 24px;
    line-height: 30px;
  }
  p {
    padding-bottom: 10px;
    font-size: 16px;
    line-height: 18px;
  }
  .dialog-footer {
    margin-top: 15px;
  }
  .header{
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    border-radius: 6px 6px 0px 0px;
    padding: 16px;
    margin: -15px;
    justify-content: space-between;
    align-items: center;
    p{
      font-weight: 600;
      font-size: 14px;
      height: 20px;
      color: #1B1F23;
    }
    .close{
      padding: 0 5px;
      cursor: pointer;
    }
  }
  .tips{
    color: #24292E;
    margin-top: 35px;
    font-weight: 400;
    font-size: 14px;
    &.color-red{
      color: #CB2431!important;
    }
    &.mg-t-10{
      margin-top: 10px;
    }
  }
}
</style>